import React from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    CircularProgress,
    Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#7e7e7e",
        color: theme.palette.common.white,
        textTransform: "capitalize",
        fontSize: 16,
        fontWeight: 600,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        textTransform: "capitalize",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd),&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const LearnerListTable = ({ data, loading }) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const navigate = useNavigate();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginatedRows = data?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <TableContainer component={Paper} className="table-container" sx={{ width: "100%", overflowX: "auto" }}>
            <Table sx={{ tableLayout: "auto", width: "max-content", minWidth: "100%" }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Email</StyledTableCell>
                        <StyledTableCell>Mobile</StyledTableCell>
                        <StyledTableCell>Average Track Score</StyledTableCell>
                        <StyledTableCell>Last Topic Name</StyledTableCell>
                        <StyledTableCell>Last Track Score</StyledTableCell>
                        <StyledTableCell>Last Remark</StyledTableCell>
                        <StyledTableCell>Last Review Date</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading ? (
                        <TableRow>
                            <StyledTableCell colSpan={8} align="center">
                                <Box display="flex" justifyContent="center" alignItems="center" height="30px">
                                    <CircularProgress />
                                </Box>
                            </StyledTableCell>
                        </TableRow>
                    ) : paginatedRows?.length > 0 ? (
                        paginatedRows.map((row, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell sx={{
                                    color: "#1976d2",
                                    cursor: `${row.learner.learner_code && "pointer"} `,
                                    textDecoration: `${row.learner.learner_code && "underline"} `,
                                    "&:hover": { color: "#004ba0" },
                                }}
                                    onClick={row.learner.learner_code ? () => navigate(`../review/learner/${row.learner.learner_code}`) : undefined}>{row.learner.name || "-"}</StyledTableCell>
                                <StyledTableCell sx={{ textTransform: "none !important" }}>{row.learner.email || "-"}</StyledTableCell>
                                <StyledTableCell>{row.learner.mobile || "-"}</StyledTableCell>
                                <StyledTableCell>{row?.track_score?.avg_track_score || "-"}</StyledTableCell>
                                <StyledTableCell>{row?.track_score?.last_topic_name || "-"}</StyledTableCell>
                                <StyledTableCell>{row?.track_score?.last_track_score || "-"}</StyledTableCell>
                                <StyledTableCell
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: 200,
                                    }}
                                >
                                    {row?.track_score?.last_track_remarks || "-"}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {row?.track_score?.last_review_date
                                        ? new Date(row?.track_score?.last_review_date).toLocaleDateString('en-GB')
                                        : '-'}
                                </StyledTableCell>
                            </StyledTableRow>
                        ))
                    ) : (
                        <StyledTableRow>
                            <StyledTableCell colSpan={8} align="center" sx={{ fontWeight: "600", color: "grey" }}>
                                No Learners found.
                            </StyledTableCell>
                        </StyledTableRow>
                    )}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[10,20,30,60,100]}
                component="div"
                count={data?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </TableContainer>
    );
};

export default LearnerListTable;
